import React, { Component } from 'react';

class Gallery extends Component {
    render() {
        return (
            <div>
                Gallery;
            </div>
        );
    }
}

export default Gallery;